import VideoListPage from "@/pages/list/components/VideoListPage";
import { movieCategories } from "@/mocks/videos";

export default function MoviePage() {
  return (
    <VideoListPage
      type="movie"
      title="电影"
      intro="在线观看各类热门电影，包括动作、爱情、科幻等多类型影视作品。支持按类型、地区、年份筛选，快速找到你喜欢的高清电影。"
      categories={movieCategories}
    />
  );
}